import { useMemo } from 'react';
import { Option } from '@trukt/portal-utils/Option';
import { Branch } from '@trukt/types/Branch';

export const useOptionWithBranchResults = (branches: Branch[] = []) => {
  const options = useMemo(
    () =>
      branches.map<Option<string>>((branch) => ({
        label: branch.name,
        value: branch.guid,
        raw: branch,
      })),
    [branches],
  );

  return options;
};
